export default __webpack_public_path__ + "empty-metadata.eeb1dafedd81be78010d4382f0448b9a.svg";